import "./index.css"
import RankingItem from "./RankingItem";

export default function PageThree() {

    return (
        <div>
            <h1 className="center-title text-light">Recent Trends</h1>
            <RankingItem musicSrc={require("../../musics/demo2.mp3")} musicName={'First Music'} creator={'Chris Chen'} token={'1.56 Lepton Token'} imgSrc={require("../../images/album1.png")}/>
            <RankingItem musicSrc={require("../../musics/demo3.mp3")} musicName={'Second Music'} creator={'Master'} token={'1.55 Lepton Token'} imgSrc={require("../../images/album2.png")}/>
            <RankingItem musicSrc={require("../../musics/demo1.mp3")} musicName={'Third Music'} creator={'Master'} token={'1.55 Lepton Token'} imgSrc={require("../../images/album3.png")}/>

        </div>
    )
}